export const companyDetails = state => state.companyDetails

export const transportIsSending = state => state.isSending
